export const FIX_SUBTITLES_TITLE = 'Fix subtitles';

export const FIX_SUBTITLES_TEXT = 'Subtitles of this video have no punctuation. \n Would you like to fix it?';

export const FIX_SUBTITLES_BUTTON_NO = 'No, thanks';

export const FIX_SUBTITLES_BUTTON_FIX = 'Fix subtitles';

export const FIX_SUBTITLES_BUTTON_CANCEL = 'Cancel';
